import React from 'react';
import find from 'lodash/find';
import get from 'lodash/get';
import InputItem from 'views/pages/ClientDetail/components/InputItem';
import {
  FormSection,
  ShouldUpdateWrapper,
} from 'views/pages/ClientDetail/components/Elements';
import { useOptions } from 'helper/hooks';
import ListSection from 'views/pages/ClientDetail/UnderwritingInfo/tabs/Background/components/ListSection';

const Pull = ({ className, isEdit, form, data }) => {
  const { scPullTypeOptions } = useOptions();
  return (
    <ListSection
      className={className}
      isEdit={isEdit}
      form={form}
      data={data['pulls'] || []}
      title="Pulls"
      addBtnText="Add Pull"
      parentName="pulls"
      fields={[
        {
          label: 'Type',
          key: 'pull_type',
          type: 'value',
        },
        {
          label: 'Date',
          key: 'date',
          type: 'date',
        },
        {
          label: 'Other',
          key: 'other',
          type: 'value',
          dependField: 'pull_type',
          dependFn: val => val !== 'Other',
        },
      ]}
      hideStatus={false}
      displayDelete={true}
      renderEditForm={index => {
        return (
          <FormSection>
            <InputItem
              name={[index, 'pull_type_id']}
              label="Type"
              form={form}
              type="select"
              options={scPullTypeOptions}
            />
            <InputItem
              name={[index, 'date']}
              label="Date"
              form={form}
              placeholder="01/01/2000"
              type="date"
              customValidateName={['pulls', index, 'date']}
            />
            <ShouldUpdateWrapper>
              {() => {
                const values = form.getFieldsValue();
                const valueObj = get(values, `pulls[${index}]`) || {};
                const foundType =
                  find(scPullTypeOptions, {
                    value: valueObj.pull_type_id,
                  }) || {};
                if (foundType.label !== 'Other') {
                  return <></>;
                }
                return (
                  <>
                    <InputItem
                      name={[index, 'other']}
                      label="Other"
                      form={form}
                    />
                  </>
                );
              }}
            </ShouldUpdateWrapper>
          </FormSection>
        );
      }}
    />
  );
};

export default Pull;
